import React, { useEffect } from "react";
import { CSSGrid, Cell } from "../../Core/Components/Styles";
import * as Utils from "./../Utils";

//EN: use empty generic type to get default react props
export const Layout: React.FC<{}> = (props) => {
    useEffect(() => {
        let handleResize = () => {
            Utils.sendPostMessage(window.document);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("onload", handleResize);

        var observer = new MutationObserver(handleResize);
        observer.observe(document.body, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("onload", handleResize);
        };
    }, []);

    return (
        <>
            <CSSGrid id="cssgrid" areas={["content"]} columns={"1fr"} gap={"0px"} rows={"70px"}>
                <Cell area={"content"} id={"content"}>
                    <div id="bqs-wrapper">{props.children}</div>
                </Cell>
            </CSSGrid>
        </>
    );
};
